import { State } from '../state';

export const reports: State = {
    url: 'reports'
};

export const reportsBalanceSheet: State = {
    url: 'reports/balance-sheet',
    parent: reports
};
export const reportsSalesByPeriod: State = {
    url: 'reports/sales-by-period',
    parent: reports
};
export const reportsSalesByClients: State = {
    url: 'reports/sales-by-clients',
    parent: reports
};
export const reportsSalesByProducts: State = {
    url: 'reports/sales-by-products',
    parent: reports
};
export const reportsUnsettledPayments: State = {
    url: 'reports/unsettled-payments',
    parent: reports
};

export const reportsPurchasesByPeriod: State = {
    url: 'reports/purchases-by-period',
    parent: reports
};

export const reportsSaleRegistry: State = {
    url: 'reports/sale-registry',
    parent: reports
};

export const reportsPurchaseRegistry: State = {
    url: 'reports/purchase-registry',
    parent: reports
};

export const reportsSalesWsto: State = {
    url: 'reports/sales-wsto',
    parent: reports
};

export const reportsInventoryStocktaking: State = {
    url: 'reports/inventory-stocktaking',
    parent: reports
};
